import { CircleNotchIcon } from '@phosphor-icons/react';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { cn } from '@/lib/utils';

interface ChangeStatusDialogProps {
  isArchived: boolean;
  isUpdating: boolean;
  isOpen: boolean;
  onSubmit: () => void;
  title: string;
  restoreDescription: string;
  archiveDescription: string;
  onOpenChange: (nextOpenState: boolean) => void;
}

export function ChangeStatusDialog({
  isOpen,
  onSubmit,
  onOpenChange,
  isUpdating,
  isArchived,
  title,
  restoreDescription,
  archiveDescription,
}: ChangeStatusDialogProps) {
  const handleSubmit = (event: React.SyntheticEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    onSubmit();
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          {isArchived ? (
            <AlertDialogDescription>
              {restoreDescription}
            </AlertDialogDescription>
          ) : (
            <AlertDialogDescription>
              {archiveDescription}
            </AlertDialogDescription>
          )}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction
            disabled={isUpdating}
            onClick={handleSubmit}
            className={cn(
              isArchived
                ? 'border-white'
                : 'text-destructive border-destructive hover:text-destructive'
            )}
            data-testid={isArchived ? 'restore-button' : 'archive-button'}
          >
            {isUpdating && <CircleNotchIcon className="animate-spin" />}
            {isArchived ? 'Restore' : 'Archive'}
          </AlertDialogAction>
          <AlertDialogCancel disabled={isUpdating}>Cancel</AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
